import React from 'react';

import {BaseMatchModel} from "../../../../../core/components/router/models/base-match-model";
import {Compose, ComposeSettings} from "../../../../../core/components/composers/compose";
import {CompetitionHighlightsPageController} from "../competition-highlights-page.controller";
import {BaseModuleProps} from "../../../../../infrastructure/models/props/base-module-props";
import {EntityHighlightsWidgetAsync} from "../../../../../widgets/entity-highlights-widget/components/entity-highlights-widget.async";

export class CompetitionHighlightsPageComponentProps extends BaseModuleProps {
  match: BaseMatchModel;
}

export const CompetitionHighlightsPageComponent = ({controller}) => {
  const {state} = controller;
  const {competitionId} = state;

  const highlightsWidgetProps = {
    controller,
    competition: competitionId,
  }

  return (
    <EntityHighlightsWidgetAsync {...highlightsWidgetProps}/>
  )
};

const settings: ComposeSettings = {
  component: CompetitionHighlightsPageComponent,

  observe: true,
  createModule: true,
  useMetadata: true,

  propsType: CompetitionHighlightsPageComponentProps,
  controllerType: CompetitionHighlightsPageController,
};

export const CompetitionHighlightsPage = Compose(settings);

export default CompetitionHighlightsPage;
